import getCups from "./getCups";

/**
 * Takes tracks from Firestore DB and converts it into a format DisplayCupTracks component renders.
 * @param {Array} tracks an array of tracks pulled from Firestore
 * @see App.js loader for route /browse/cup/:cupid
 * @returns a new array with proper track data rather than raw cup data + original index.
 */
export default function getTracks(tracks) {
    const cups = getCups();
    return tracks.map(element => {
      const index = element.originIndex;
      return { 
        emblem: cups.get(element.cup).emblem,
        name: cups.get(element.cup).tracks[index].name,
        origin: cups.get(element.cup).tracks[index].origin,
        image: cups.get(element.cup).tracks[index].image
      }
    });
  }